import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
const VARIANT_CLASSES = {
    success: 'bg-success-soft text-success',
    warning: 'bg-amber-soft text-amber-text',
    danger: 'bg-danger-soft text-danger',
    info: 'bg-info-soft text-info-text',
};
/** The one inline-banner shape every screen already uses ad hoc
 * (`role="alert"` + a soft-tint background) — formalized so new screens
 * reach for this instead of re-typing the same four Tailwind classes. */
export function Alert({ variant, children, errorId, className }) {
    return (_jsxs("div", { role: "alert", className: clsx('rounded-control px-3 py-2 text-sm font-medium', VARIANT_CLASSES[variant], className), children: [children, errorId && _jsxs("span", { className: "ml-2 font-mono text-xs opacity-70", children: ["Ref: ", errorId] })] }));
}
/** A transient, self-dismissing toast — same visual language as `Alert`,
 * fixed to a screen corner. Callers own the timer/visibility; this is
 * purely presentational so it composes with whatever toast-queue state
 * management a screen already has. */
export function Toast({ variant, children, onDismiss }) {
    return (_jsxs("div", { role: "status", className: clsx('flex items-center gap-3 rounded-card px-4 py-3 text-sm font-medium shadow-popover', VARIANT_CLASSES[variant]), children: [_jsx("span", { className: "flex-1", children: children }), onDismiss && (_jsx("button", { type: "button", onClick: onDismiss, "aria-label": "Dismiss", className: "text-current opacity-70 hover:opacity-100", children: "\u00D7" }))] }));
}
//# sourceMappingURL=Alert.js.map